import { h } from '@stencil/core';
import cn from 'classnames';
export class PesLogo {
  constructor() {
    this.logo = undefined;
    this.title = undefined;
    this.containerClassName = undefined;
    this.logoClassName = undefined;
    this.titleClassName = undefined;
  }
  render() {
    var _a, _b;
    return (h("div", { class: cn('logo__container', this.containerClassName) }, h("img", { src: (_a = this.logo) === null || _a === void 0 ? void 0 : _a.url, alt: (_b = this.logo) === null || _b === void 0 ? void 0 : _b.alt, class: cn('pes__logo', this.logoClassName) }), this.title && (h("qds-title", { class: cn('pes__title', this.titleClassName), layer: "main", level: "subsection", alignment: "start" }, this.title))));
  }
  static get is() { return "pes-logo"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-logo.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-logo.css"]
    };
  }
  static get properties() {
    return {
      "logo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "LogoInfo",
          "resolved": "{ url?: string; absoluteUrl?: string; alt?: string; }",
          "references": {
            "LogoInfo": {
              "location": "import",
              "path": "../../global-types/common"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines logo attributes like url alt text and absolute URl"
        }
      },
      "title": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines title of the logo"
        },
        "attribute": "title",
        "reflect": false
      },
      "containerClassName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines custom class  for the container"
        },
        "attribute": "container-class-name",
        "reflect": false
      },
      "logoClassName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines custom class  for the logo"
        },
        "attribute": "logo-class-name",
        "reflect": false
      },
      "titleClassName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines custom class  for the title"
        },
        "attribute": "title-class-name",
        "reflect": false
      }
    };
  }
}
